import { isValidInput } from "../../utils/validations";
import { TKeyStringFunction } from "./types";
import { InstallmentsPlans } from "../../pages/Installments/InstallmentsForm/types";

export const generateInstallmentsPlans = (installmentsSelected): InstallmentsPlans => {
  const result: InstallmentsPlans = {
    1: {
      tem: null,
      tna: null,
      planAhora: false,
      coefficient: 1
    },
  };

  for (const [key , value] of installmentsSelected) {
    switch (value) {
      case "SIMPLE_WITH_INT":
        result[key] = {
          tem: null,
          tna: null,
          planAhora: true,
          coefficient: null
        };
        break;

      case "SIMPLE_WITHOUT_INT":
        result[key] = {
          tem: 0,
          tna: 0,
          planAhora: true,
          coefficient: 1
        };
        break;

      case "TRAD_WITH_INT":
        result[key] = {
          tem: null,
          tna: null,
          planAhora: false,
          coefficient: null
        };
        break;

      case "TRAD_WITHOUT_INT":
        result[key] = {
          tem: 0,
          tna: 0,
          planAhora: false,
          coefficient: 1
        };
        break;

      default:
        break;
    }
  }

  return result;
};

export const validateFormInput = (name: string, value: string) => {
  const validator: TKeyStringFunction = {
    3: () => isValidInput(value),
    6: () => isValidInput(value),
    12: () => isValidInput(value),
    18: () => isValidInput(value),
    24: () => isValidInput(value),
    "american_express": () => isValidInput(value),
    "cabal": () => isValidInput(value),
    "maestro": () => isValidInput(value),
    "naranja": () => isValidInput(value),
    "diners_club": () => isValidInput(value),
    "confiable": () => isValidInput(value),
  };
  return validator[name](value);
};